import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc, doc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus, faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import HeaderPages from "Components/HeaderPages/HeaderPages";
import "./Reports.css";

const SpecialtyOptionsManager = () => {
  const [specialties, setSpecialties] = useState([]);
  const [newSpecialty, setNewSpecialty] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);

  // Fetch all specialty options when component mounts
  useEffect(() => {
    fetchSpecialties();
  }, []);

  const fetchSpecialties = async () => {
    setFetchLoading(true);
    try {
      const specialtiesRef = collection(db, "Specialties");
      const snapshot = await getDocs(specialtiesRef);
      const specialtiesList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setSpecialties(specialtiesList);
    } catch (error) {
      console.error("Error fetching specialties:", error);
      toast.error("Failed to fetch specialties");
    } finally {
      setFetchLoading(false);
    }
  };

  const handleAddSpecialty = async (e) => {
    e.preventDefault();
    
    if (!newSpecialty.trim()) {
      toast.error("Specialty name cannot be empty");
      return;
    }

    // Check if specialty already exists
    const exists = specialties.some(
      specialty => specialty.value.toLowerCase() === newSpecialty.toLowerCase()
    );
    
    if (exists) {
      toast.error("This specialty already exists");
      return;
    }

    setLoading(true);
    try {
      const specialtiesRef = collection(db, "Specialties");
      const newSpecialtyData = {
        value: newSpecialty,
        label: newSpecialty
      };
      
      await addDoc(specialtiesRef, newSpecialtyData);
      setNewSpecialty("");
      toast.success("Specialty added successfully");
      fetchSpecialties();
    } catch (error) {
      console.error("Error adding specialty:", error);
      toast.error("Failed to add specialty");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSpecialty = async (id) => {
    try {
      const specialtyRef = doc(db, "Specialties", id);
      await deleteDoc(specialtyRef);
      toast.success("Specialty deleted successfully");
      fetchSpecialties();
    } catch (error) {
      console.error("Error deleting specialty:", error);
      toast.error("Failed to delete specialty");
    }
  };

  return (
    <div className="project-management-request all-main specialty-container">
      {/* Breadcrumb Navigation */}
      <HeaderPages titlePage="Manage Specialties" />

      <div className="specialty-card">
        <h3 className="specialty-card-title">
          <FontAwesomeIcon icon={faPlus} style={{ color: "var(--blue-main-color)" }} />
          Add Specialty Option
        </h3>
        
        <form onSubmit={handleAddSpecialty} className="add-specialty-form">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Enter new specialty option (e.g. Orthodontics)"
              value={newSpecialty}
              onChange={(e) => setNewSpecialty(e.target.value)}
            />
            <button 
              className="btn btn-add-specialty d-flex align-items-center gap-2" 
              type="submit" 
              disabled={loading}
            >
              {loading ? (
                <span className="loader"></span>
              ) : (
                <>
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Add Specialty</span>
                </>
              )}
            </button>
          </div>
        </form>
        
        <div className="specialties-list mt-5">
          <h3 className="specialty-card-title mt-2">
            <FontAwesomeIcon icon={faFolderOpen} style={{ color: "var(--blue-main-color)" }} />
            Current Specialties
          </h3>
          {fetchLoading ? (
            <div className="text-center py-4">
              <span className="loader"></span>
            </div>
          ) : specialties.length === 0 ? (
            <p className="text-center text-muted py-4">No specialties found. Add your first option above.</p>
          ) : (
            <div className="specialties-grid">
              {specialties.map((specialty) => (
                <div key={specialty.id} className="specialty-chip">
                  <span>{specialty.label}</span>
                  <button
                    type="button"
                    className="btn-chip-delete"
                    onClick={() => handleDeleteSpecialty(specialty.id)}
                    title="Delete Option"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SpecialtyOptionsManager;